<template>
    <div :class="divWrapper">
        <div :class="divItems">
            <div
                :class="[divItem, getChecked(boxItem.name)]"
                v-for="(boxItem, index) in filtedBoxes"
                :key="index"
                @click="changeSelected"
                v-html="boxItem.name"
            >
                {{ boxItem.name }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "SearchBoxes",
    emits: ["submit-boxes"],
    props: {
        className: { type: String, default: "custom-select" },
        boxesItems: Array,
        makeEmpty: Boolean,
    },
    data() {
        return {
            selected: "",
        };
    },
    computed: {
        divWrapper() {
            return `${this.className}--boxes`;
        },
        divSelected() {
            return `${this.className}--boxes__selected`;
        },
        divSearch() {
            return `${this.className}--boxes__search`;
        },
        divItems() {
            return `${this.className}--boxes__items`;
        },
        divItem() {
            return `${this.className}--boxes__item`;
        },
        filtedBoxes() {
            return this.boxesItems.filter((item) => {
                return item.name.toLowerCase();
            });
        },
    },
    watch: {
        makeEmpty(val) {
            if (!val) return;
            this.selected = "";
            this.submitData();
        },
    },
    methods: {
        getChecked(boxes) {
            if (this.selected.indexOf(boxes) !== -1) return "checked";
        },
        changeSelected(event) {
            const result = event.target.innerHTML.trim();
            this.selected === result
                ? (this.selected = "")
                : (this.selected = result);

            this.submitData();
        },
        submitData() {
            this.$emit("submit-boxes", this.selected);
        },
    },
    updated() {
        // console.log("boxes update");
    },
};
</script>
